import { render, staticRenderFns } from "./mySampleBorrowing.vue?vue&type=template&id=08a7f7ca&scoped=true&"
import script from "./mySampleBorrowing.vue?vue&type=script&lang=js&"
export * from "./mySampleBorrowing.vue?vue&type=script&lang=js&"
import style0 from "./mySampleBorrowing.vue?vue&type=style&index=0&id=08a7f7ca&lang=scss&scoped=true&"
import style1 from "./mySampleBorrowing.vue?vue&type=style&index=1&lang=css&"
import style2 from "./mySampleBorrowing.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7f7ca",
  null
  
)

export default component.exports